export function updateOrPush(newItem, ref) {
    const array = this || [];
    const clonedArray = [...array];
    if (clonedArray.find((item) => item[ref] === newItem[ref])) {
        return clonedArray.map((item) => {
            if (item[ref] !== newItem[ref])
                return item;
            return newItem;
        });
    }
    clonedArray.push(newItem);
    return clonedArray;
}
//# sourceMappingURL=updateOrPush.js.map